import { clone } from "lodash";
import * as React from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";
import * as AccountStore from "./AccountStore";
import HumanJson  from "../human";

const { Component } = React;


interface ProfileDataState {
    currentUser: any;
    user: any;
    humanJson: any;
}

export default class ProfileData extends Component<any, ProfileDataState> {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: {},
            user: { twoFactorEnabled: false },
            humanJson: "",
        };
    }

    componentDidMount() {
        this.GetCurrentUser();
    }

    GetCurrentUser = () => {
        AccountStore.GetCurrentLoggedInUser(true).then((user) => {
            this.setState({
                currentUser: user,
                user: clone(user),
                humanJson: HumanJson.format(user.data || {}),
            });
        });
    };

    render() {
        return (
            <div style={{ marginTop: "47px" }} className="px-4">
                <h1>
                    {this.state.currentUser.firstName} {this.state.currentUser.lastName}
                </h1>
                <h2>{this.state.currentUser.email}</h2>
                <p>{this.state.currentUser.userName}</p>

                <div className="m-2">
                    <Link to="/profile">Profile</Link>
                    <Link to="/profile/data" className="ms-2">
                        Data
                    </Link>
                    <Link to="/profile/mfa" className="ms-2">
                        MFA
                    </Link>
                    <Link to="/profile/security" className="ms-2">
                        Security
                    </Link>
                </div>

                <Row>
                    <Col md={12} lg={4}>
                        <div dangerouslySetInnerHTML={{ __html: this.state.humanJson.outerHTML }} />
                    </Col>
                </Row>
            </div>
        );
    }
}
